import React, { useEffect } from 'react'
import PrimaryButton from '../../../../../components/PrimaryButton'
import { InputAdornment, TextField } from '@mui/material'
import { computePercentageReduction } from '../../../../../utils/helpers'
import ReactGA from 'react-ga4'
import TranslationText, { replaceArray } from '../../../../../components/TranslationText'

interface ReduceBlockProps {
  setMoney: (money: number) => void
  co2: number
  country?: string
}

interface ReduceCardProps {
  title: string
  amount: string | 'input'
  lines: string[]
  onClick: (money: number) => void
  co2: number
  country?: string
}

const CardElements = [
  {
    title: 'landing-page.reduce-block.card1.title',
    amount: '29',
    lines: [
      'landing-page.reduce-block.card1.line1',
      'landing-page.reduce-block.card1.line2',
      'landing-page.reduce-block.card1.line3',
    ],
  },
  {
    title: 'landing-page.reduce-block.card2.title',
    amount: '69',
    lines: [
      'landing-page.reduce-block.card2.line1',
      'landing-page.reduce-block.card2.line2',
      'landing-page.reduce-block.card2.line3',
    ],
  },
  {
    title: 'landing-page.reduce-block.card3.title',
    amount: '149',
    lines: [
      'landing-page.reduce-block.card3.line1',
      'landing-page.reduce-block.card3.line2',
      'landing-page.reduce-block.card3.line3',
    ],
  },
  {
    title: 'landing-page.reduce-block.card4.title',
    amount: 'input',
    lines: [
      'landing-page.reduce-block.card4.line1',
      'landing-page.reduce-block.card4.line2',
      'landing-page.reduce-block.card4.line3',
    ],
  },
]


const InfoLine = ({ text, replace }: { text: string, replace: replaceArray[] }) => (
  <div className='self-stretch justify-start items-center gap-2 inline-flex'>
    <div className='w-8 h-8 relative'>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.4764 5.90231C13.1107 6.21898 12.6725 6.55243 12.1715 6.76082C11.6668 6.97077 11.1215 7.04228 10.6416 7.07382C10.3273 7.09448 9.97668 7.10007 9.65709 7.10517C9.50544 7.10759 9.36078 7.1099 9.23032 7.11365C8.26905 7.1413 7.77973 7.25949 7.51961 7.51961C7.26095 7.77827 7.14752 8.25302 7.12311 9.20836C7.11998 9.33071 7.11812 9.46493 7.11617 9.60565C7.11163 9.9321 7.10661 10.2935 7.08422 10.6227C7.0511 11.1097 6.97546 11.659 6.75988 12.1738C6.54654 12.6832 6.21293 13.1255 5.8927 13.4964C5.67424 13.7495 5.42223 14.0126 5.19353 14.2513C5.0962 14.3529 5.0031 14.4501 4.9186 14.5402C4.60965 14.8697 4.37092 15.1495 4.20848 15.413C4.05009 15.67 4 15.8551 4 16C4 16.1436 4.05064 16.3317 4.21248 16.5948C4.37753 16.8631 4.61952 17.1481 4.92944 17.4801C5.01803 17.575 5.11631 17.6779 5.21898 17.7854C5.44426 18.0212 5.69069 18.2791 5.90231 18.5236C6.21898 18.8893 6.55243 19.3275 6.76082 19.8285C6.97077 20.3332 7.04228 20.8785 7.07382 21.3584C7.09448 21.6727 7.10007 22.0233 7.10517 22.3429C7.10759 22.4946 7.1099 22.6392 7.11365 22.7697C7.1413 23.7309 7.25949 24.2203 7.51961 24.4804C7.77827 24.7391 8.25302 24.8525 9.20836 24.8769C9.33073 24.88 9.46496 24.8819 9.60569 24.8838C9.93213 24.8884 10.2935 24.8934 10.6227 24.9158C11.1097 24.9489 11.659 25.0245 12.1738 25.2401C12.6832 25.4535 13.1255 25.7871 13.4964 26.1073C13.7495 26.3258 14.0125 26.5778 14.2513 26.8065C14.3529 26.9038 14.4501 26.9969 14.5402 27.0814C14.8697 27.3903 15.1495 27.6291 15.413 27.7915C15.67 27.9499 15.8551 28 16 28C16.1436 28 16.3317 27.9494 16.5948 27.7875C16.8631 27.6225 17.1481 27.3805 17.4801 27.0706C17.575 26.982 17.6779 26.8837 17.7854 26.781C18.0212 26.5557 18.2791 26.3093 18.5236 26.0977C18.8893 25.781 19.3275 25.4476 19.8285 25.2392C20.3332 25.0292 20.8785 24.9577 21.3584 24.9262C21.6727 24.9055 22.0233 24.8999 22.3429 24.8948C22.4945 24.8924 22.6392 24.8901 22.7697 24.8864C23.7309 24.8587 24.2203 24.7405 24.4804 24.4804C24.7391 24.2217 24.8525 23.747 24.8769 22.7916C24.88 22.6693 24.8819 22.535 24.8838 22.3943C24.8884 22.0679 24.8934 21.7065 24.9158 21.3773C24.9489 20.8903 25.0245 20.341 25.2401 19.8262C25.4535 19.3168 25.7871 18.8745 26.1073 18.5036C26.3258 18.2505 26.5778 17.9875 26.8065 17.7487C26.9038 17.6471 26.9969 17.5499 27.0814 17.4598C27.3903 17.1303 27.6291 16.8505 27.7915 16.587C27.9499 16.33 28 16.1449 28 16C28 15.8564 27.9494 15.6683 27.7875 15.4052C27.6225 15.1369 27.3805 14.8519 27.0706 14.5199C26.982 14.425 26.8837 14.3221 26.781 14.2146C26.5557 13.9788 26.3093 13.7209 26.0977 13.4764C25.781 13.1107 25.4476 12.6725 25.2392 12.1715C25.0292 11.6668 24.9577 11.1215 24.9262 10.6416C24.9055 10.3273 24.8999 9.9767 24.8948 9.65712C24.8924 9.50546 24.8901 9.36079 24.8864 9.23032C24.8587 8.26905 24.7405 7.77973 24.4804 7.51961C24.2217 7.26095 23.747 7.14752 22.7916 7.12311C22.6693 7.11998 22.5351 7.11812 22.3944 7.11617C22.0679 7.11163 21.7065 7.10661 21.3773 7.08422C20.8903 7.0511 20.341 6.97546 19.8262 6.75988C19.3168 6.54654 18.8745 6.21293 18.5036 5.8927C18.2505 5.67424 17.9874 5.42223 17.7487 5.19353C17.6471 5.0962 17.5499 5.0031 17.4598 4.9186C17.1303 4.60965 16.8505 4.37092 16.587 4.20848C16.33 4.05009 16.1449 4 16 4C15.8564 4 15.6683 4.05064 15.4052 4.21248C15.1369 4.37753 14.8519 4.61952 14.5199 4.92944C14.425 5.01803 14.3221 5.11631 14.2146 5.21898C13.9788 5.44426 13.7209 5.69069 13.4764 5.90231ZM14.3573 2.509C14.8098 2.23061 15.3623 2 16 2C16.6363 2 17.1856 2.22803 17.6365 2.50597C18.0808 2.77986 18.4822 3.13566 18.8277 3.45953C18.9535 3.57743 19.0695 3.68871 19.1805 3.79508C19.3986 4.00427 19.597 4.19448 19.8105 4.37878C20.1224 4.64801 20.3769 4.82221 20.5988 4.91512C20.8153 5.00579 21.1097 5.0614 21.513 5.08883C21.7883 5.10756 22.0554 5.11112 22.3511 5.11506C22.5054 5.11712 22.6675 5.11929 22.8427 5.12376C23.7218 5.14623 25.0033 5.21405 25.8946 6.10539C26.7845 6.99527 26.8601 8.2872 26.8855 9.17281C26.891 9.36206 26.8936 9.5352 26.8961 9.69933C26.9004 9.98449 26.9043 10.2424 26.9219 10.5104C26.9485 10.916 27.002 11.202 27.0858 11.4035C27.1712 11.6087 27.3393 11.855 27.6097 12.1673C27.7903 12.3759 27.9758 12.5698 28.1798 12.7831C28.2912 12.8995 28.408 13.0217 28.5326 13.1551C28.8586 13.5044 29.2158 13.91 29.491 14.3573C29.7694 14.8098 30 15.3623 30 16C30 16.6363 29.772 17.1856 29.494 17.6365C29.2201 18.0808 28.8643 18.4822 28.5405 18.8277C28.4226 18.9534 28.3113 19.0695 28.2049 19.1804C27.9957 19.3986 27.8055 19.597 27.6212 19.8105C27.352 20.1224 27.1778 20.3769 27.0849 20.5988C26.9942 20.8153 26.9386 21.1097 26.9112 21.513C26.8924 21.7883 26.8889 22.0553 26.8849 22.3511C26.8829 22.5054 26.8807 22.6675 26.8762 22.8427C26.8538 23.7218 26.7859 25.0033 25.8946 25.8946C25.0047 26.7845 23.7128 26.8601 22.8272 26.8855C22.6379 26.891 22.4648 26.8936 22.3007 26.8961C22.0155 26.9004 21.7576 26.9043 21.4896 26.9219C21.084 26.9485 20.798 27.002 20.5965 27.0858C20.3913 27.1712 20.145 27.3393 19.8327 27.6097C19.6241 27.7903 19.4302 27.9758 19.2169 28.1798C19.1005 28.2912 18.9783 28.408 18.8449 28.5326C18.4956 28.8586 18.09 29.2158 17.6427 29.491C17.1902 29.7694 16.6377 30 16 30C15.3637 30 14.8144 29.772 14.3635 29.494C13.9192 29.2201 13.5178 28.8643 13.1723 28.5405C13.0465 28.4226 12.9305 28.3113 12.8196 28.2049C12.6014 27.9957 12.403 27.8055 12.1895 27.6212C11.8776 27.352 11.6231 27.1778 11.4012 27.0849C11.1847 26.9942 10.8903 26.9386 10.487 26.9112C10.2117 26.8924 9.94465 26.8889 9.64895 26.8849C9.49462 26.8829 9.33249 26.8807 9.15727 26.8762C8.27823 26.8538 6.99673 26.7859 6.10539 25.8946C5.21552 25.0047 5.13995 23.7128 5.11448 22.8272C5.10903 22.6379 5.10642 22.4648 5.10394 22.3007C5.09964 22.0155 5.09574 21.7576 5.07813 21.4896C5.05147 21.084 4.99798 20.798 4.91418 20.5965C4.82882 20.3913 4.66071 20.145 4.39027 19.8327C4.20972 19.6241 4.02422 19.4302 3.82016 19.2169C3.70885 19.1005 3.59201 18.9783 3.46744 18.8449C3.14142 18.4956 2.78418 18.09 2.509 17.6427C2.23061 17.1902 2 16.6377 2 16C2 15.3637 2.22803 14.8144 2.50597 14.3635C2.77986 13.9192 3.13566 13.5178 3.45953 13.1723C3.57743 13.0465 3.68871 12.9305 3.79508 12.8195C4.00427 12.6014 4.19448 12.403 4.37878 12.1895C4.64801 11.8776 4.82221 11.6231 4.91512 11.4012C5.00579 11.1847 5.0614 10.8903 5.08883 10.487C5.10756 10.2117 5.11112 9.94465 5.11506 9.64894C5.11712 9.49462 5.11929 9.33249 5.12376 9.15727C5.14623 8.27823 5.21405 6.99673 6.10539 6.10539C6.99527 5.21552 8.2872 5.13995 9.17281 5.11448C9.36206 5.10903 9.5352 5.10642 9.69932 5.10394C9.98449 5.09964 10.2424 5.09574 10.5104 5.07813C10.916 5.05147 11.202 4.99798 11.4035 4.91418C11.6087 4.82882 11.855 4.66071 12.1673 4.39027C12.3759 4.20972 12.5698 4.02422 12.7832 3.82016C12.8995 3.70885 13.0217 3.59201 13.1551 3.46744C13.5044 3.14142 13.91 2.78418 14.3573 2.509Z'
          fill='#4ACC57'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.2236 12.3097C22.6048 12.7093 22.5899 13.3423 22.1903 13.7236L14.8528 20.7236C14.4662 21.0924 13.8579 21.0921 13.4716 20.723L9.80912 17.223C9.40983 16.8414 9.39547 16.2084 9.77704 15.8091C10.1586 15.4098 10.7916 15.3955 11.1909 15.777L14.1631 18.6174L20.8097 12.2765C21.2093 11.8952 21.8423 11.9101 22.2236 12.3097Z'
          fill='#4ACC57'
        />
      </svg>
    </div>
    <div className='grow shrink basis-0 text-start'>
      <TranslationText translationKey={text} replace={replace} />
    </div>
  </div>
)
const ReduceCard: React.FC<ReduceCardProps> = ({ title, amount, lines, onClick, co2, country }) => {
  const [inputAmount, setAmount] = React.useState('50')
  const [error, setError] = React.useState<string | null>(null)
  const pricePerMT = 16.51
  // const reducePercentage = co2 ? (co2 * pricePerMT) / (
  //   amount === 'input' ? parseInt(inputAmount) : parseInt(amount) | 0
  // )  : 0

  const reducePercentage = computePercentageReduction(co2, pricePerMT, (amount === 'input' ? parseInt(inputAmount) : parseInt(amount) | 0))
  useEffect(() => {
    if (parseInt(inputAmount) < 20) {
      setError('Amount must be greater than 20')
    } else if (parseInt(inputAmount) > 900) {
      setError('Amount must be less than 900')
    } else if (amount === 'input' && !inputAmount) {
      setError('Amount is required')
    } else {
      setError(null)
    }
  }, [inputAmount])


  return (
    <div
      className='w-full px-4 pt-10 pb-6 from-gray-100 to-white rounded-2xl shadow-md flex-col justify-center items-center gap-4 inline-flex'
      style={{
        background: 'linear-gradient(180deg, #F4F5F8 0%, #FFFFFF 100%)',
      }}
    >
      <TranslationText translationKey={title}
                       className='w-full text-center text-black text-[23px] font-bold leading-[27px]' />
      <div className='flex-col justify-start items-center flex w-full'>
        <div className='justify-center items-center flex w-full'>
          {amount === 'input' ? (
            <TextField
              variant='outlined'
              color={'primary'}
              // label={'Amount'}
              className={'!w-full !font-bold'}
              value={inputAmount}
              style={{ marginBottom: '16px' }}
              onChange={(e) => {
                const regex = /^[0-9\b]+$/
                if (e.target.value === '' || regex.test(e.target.value)) setAmount(e.target.value)
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '15px',
                  backgroundColor: '#FFFFFF',
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <svg width='40' height='41' viewBox='0 0 40 41' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M23.1804 17.9983L22.3924 19.7158H11.75L12.3948 17.9983H23.1804ZM21.6601 21.2842L20.7925 23.0409H11.75L12.3948 21.2842H21.6601ZM25.25 13.7086L23.9764 16.3907C23.7641 16.2443 23.5068 16.0848 23.2043 15.9123C22.9071 15.7346 22.5649 15.5856 22.1775 15.4653C21.7954 15.3398 21.3709 15.2771 20.9039 15.2771C20.1663 15.2771 19.5242 15.4601 18.9776 15.826C18.431 16.192 18.0065 16.7619 17.704 17.5356C17.4068 18.3094 17.2583 19.3028 17.2583 20.5157C17.2583 21.7391 17.4068 22.735 17.704 23.5036C18.0065 24.2669 18.431 24.8289 18.9776 25.1896C19.5242 25.5452 20.1663 25.7229 20.9039 25.7229C21.3709 25.7229 21.7954 25.6628 22.1775 25.5425C22.5596 25.4223 22.8939 25.2785 23.1804 25.1112C23.4723 24.9439 23.7164 24.7897 23.9127 24.6485L25.2022 27.3306C24.6238 27.8011 23.9685 28.1566 23.2361 28.3971C22.5038 28.6324 21.7264 28.75 20.9039 28.75C19.5136 28.75 18.2824 28.4259 17.2105 27.7776C16.1439 27.1241 15.3081 26.1856 14.7031 24.9622C14.0982 23.7336 13.7957 22.2514 13.7957 20.5157C13.7957 18.7852 14.0982 17.303 14.7031 16.0692C15.3081 14.8353 16.1439 13.8916 17.2105 13.2381C18.2824 12.5794 19.5136 12.25 20.9039 12.25C21.7583 12.25 22.5489 12.3755 23.2759 12.6264C24.0029 12.8774 24.661 13.2381 25.25 13.7086Z'
                        fill='#1B1C1D' />
                    </svg>
                  </InputAdornment>
                ),
              }}
              error={!!error}
              helperText={error}
            />
          ) : (
            <div className="text-center text-zinc-900 text-[80px] font-bold font-['Inter'] leading-[88px]">
              €{amount}
            </div>
          )}
        </div>
        <div className="text-center text-[#ABB2B4] text-lg font-bold font-['Inter'] leading-snug">
          one-time payment
        </div>
      </div>
      <div className=' p-6 bg-[#F4F5F5]  rounded-2xl flex-col justify-center items-center gap-6 flex'>
        {lines?.map((line, index) => (
          <InfoLine key={`infoLine:key:${index}`}
                    replace={[{
                      key: '{x1}',
                      value: reducePercentage ? reducePercentage.toFixed(2) : '0',
                    }, {
                      key: '{x2}',
                      value: country ? 'the average annual person\'s' : 'your annual ',
                    },
                      {
                        key: '{x3}',
                        value: country ? ' in the Netherlands' : '',
                      },
                    ]}
                    text={line} />
        ))}
      </div>
      <div className='flex-col justify-center items-center gap-4 flex w-full'>
        <PrimaryButton
          onClick={() => {
            ReactGA.event({
              category: amount === 'input' ? 'customInput' : `value${amount}`,
              action: 'Click on Make an impact',
              label: amount === 'input' ? `${inputAmount}` : `${amount}`,
            })
            onClick(amount === 'input' ? parseInt(inputAmount) : parseInt(amount))
          }}
          disabled={inputAmount !== '0001' && !!error}
        >
          <TranslationText translationKey={'landing-page.photo-list.card.button'}
                           className={'normal-case text-active-green text-[24px] font-bold'} />
        </PrimaryButton>
      </div>
    </div>
  )
}

const ReduceBlock: React.FC<ReduceBlockProps> = ({ setMoney, co2, country }) => {
  return (
    <div className='w-full mt-[40px] gap-[33px] flex flex-col items-center justify-center px-4' id={'reduce-block'}>
      <div className="w-full text-center text-stone-900 text-[32px] font-bold font-['Inter'] leading-[35px]">
        Fight the climate crisis by funding climate solutions
      </div>
      {CardElements.map((card) => (
        <ReduceCard
          key={`reduceCard:key:${card.title}`}
          title={card.title}
          amount={card.amount}
          co2={co2}
          lines={card.lines}
          country={country}
          onClick={(money) => {
            setMoney(money)
          }}
        />
      ))}
    </div>
  )
}

export default ReduceBlock
